import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnsplashComponent } from './simple-icons-unsplash.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnsplashComponent ],
    exports:      [ SimpleIconsUnsplashComponent ],
    bootstrap:    []
})
export class SimpleIconsUnsplashModule {}
